module.exports = __webpack_public_path__ + "static/media/5.da35519f.png";